export default __webpack_public_path__ + "static/media/img8.aeb50505.jpg";